import { FC, PropsWithChildren } from "react";
import styles from "../Pricing.module.scss";
import { getScreenSize } from "@utils/getScreenSize";
import cn from "classnames";

const NftSniper: FC<PropsWithChildren> = ({ children }) => {
    const { isMobile } = getScreenSize();

    return (
        <div className={styles.item}>
            <div className={cn(styles.itemBanner, styles.itemBannerNFT)}>
                <div className={styles.badgeHolder}>
                    <span className={styles.badge}>Popular</span>
                </div>
                <h2 className={styles.itemHeadline}>NFT Sniper</h2>
                <p className={styles.itemDescription}>Unlimited fast transactions, sniper and more</p>
            </div>
            {isMobile && (
                <>
                    <span className={styles.time}>Unlimited</span>
                    {children}
                </>
            )}
            <ul className={styles.list}>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Fast transaction (Endlessly)</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Sniper mode (Endlessly)</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Private community</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Communication with the project team</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Merch from Nest</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>3D NFT Model (Premium)</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>10% cashback from transactions</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Improved referral system</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Improved bonus system</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Project insights</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Whitelist of the presale</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Partner projects advantages</span>
                </li>
            </ul>
            {!isMobile && (
                <>
                    <span className={styles.time}>Unlimited</span>
                    {children}
                </>
            )}
        </div>
    );
};

export default NftSniper;
